'use strict';

export const ViewType = {
	Grid: 'Grid',
	Table: 'Table',
};

//=================================================================================================================

export const FilterType = {
	all: 'all',
	popular: 'popular',
	category: 'category',
	risk: 'risk',
	tone: 'tone',
	search: 'search',
};
